export const REQUIREMENT_TYPE_OPTIONS = [
  'High',
  'Medium',
  'Low',
  'On-Hold-Internal',
  'On Hold- Customer',
  'Fulfilled',
  'Closed',
  'Reopned',
];

const LEGACY_TYPE_MAP = {
  hot: 'High',
  warm: 'Medium',
  cold: 'Low',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  hold: 'On-Hold-Internal',
  Hold: 'On-Hold-Internal',
  cancel: 'Closed',
  Cancel: 'Closed',
  closed: 'Closed',
};

const BLOCKED_REQUIREMENT_TYPES = new Set([
  'On-Hold-Internal',
  'On Hold- Customer',
  'Fulfilled',
  'Closed',
  'Cancelled',
  'Hold',
  'Cancel',
]);

const SORT_ORDER = {
  High: 1,
  Medium: 2,
  Low: 3,
  'On-Hold-Internal': 4,
  'On Hold- Customer': 5,
  Fulfilled: 6,
  Closed: 7,
  Reopned: 8,
  Hold: 9,
  Cancel: 10,
};

export function normalizeRequirementType(type) {
  const raw = String(type || '').trim();
  if (!raw) return '';
  return LEGACY_TYPE_MAP[raw] || LEGACY_TYPE_MAP[raw.toLowerCase()] || raw;
}

export function isRequirementWorkBlocked(type) {
  const normalized = normalizeRequirementType(type);
  return BLOCKED_REQUIREMENT_TYPES.has(normalized);
}

export function getRequirementTypeSortIndex(type) {
  return SORT_ORDER[normalizeRequirementType(type)] || 99;
}

export function matchesRequirementTypeFilter(type, selectedTypes = []) {
  if (!selectedTypes.length) return true;
  const normalized = normalizeRequirementType(type);
  return selectedTypes.includes(normalized)
    || selectedTypes.some((value) => normalizeRequirementType(value) === normalized);
}
